import React, {useState, useEffect} from 'react';
import SliderCards from "../SliderCards";

function Albums(props) {
    const [data, setData] = useState([])
    const [isChange, setIsChange] = useState(false)

    useEffect(() => {
        const updatedData = props.data.map(item => ({
            image: item.image,
            title: item.name,
            subTitle: item.yearRelease,
            id: item.id,
        }));
        setData(updatedData);
        setIsChange(true)
    }, [props.data]);


    return (
        <div
            className='basis-full md:basis-2/3 flex flex-col'>
            <div className="flex flex-row items-center text-violet-700 font-black text-base md:text-lg mb-4">
                آلبوم
            </div>
            {isChange && <SliderCards data={data} />}
        </div>
    );
}

export default Albums;